<template>
  <div class="body">
    <el-dialog
      title="修改成员信息"
      :visible.sync="dialogVisible"
      append-to-body
    >
      <el-form ref="form" :model="form" label-width="100px" class="dialog">
        <el-form-item label="姓名">
          <el-input style="width: 300px" v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="年龄">
          <el-input style="width: 300px" v-model="form.age"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-select style="width: 300px" v-model="form.sex">
            <el-option label="男" value="1"></el-option>
            <el-option label="女" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input style="width: 300px" v-model="form.idcard"></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input style="width: 300px" v-model="form.mobile"></el-input>
        </el-form-item>
        <el-form-item label="地区">
          <el-select style="width: 300px" v-model="form.area">
            <el-option
              v-for="item in allWzArea"
              :key="item.name"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工作单位">
          <el-input style="width: 300px" v-model="form.work_unit"></el-input>
        </el-form-item>
        <el-form-item label="职务">
          <el-input style="width: 300px" v-model="form.role"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input style="width: 300px" v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item label="学历">
          <el-select style="width: 300px" v-model="form.education">
            <el-option label="小学" value="1"></el-option>
            <el-option label="初中" value="2"></el-option>
            <el-option label="高中" value="3"></el-option>
            <el-option label="大专" value="4"></el-option>
            <el-option label="本科" value="5"></el-option>
            <el-option label="硕士" value="6"></el-option>
            <el-option label="博士" value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否指导员">
          <el-select
            style="width: 300px; margin-bottom: 12px"
            v-model="form.is_zdy"
          >
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
          <template v-if="form.is_zdy == 1">
            <!-- <el-upload ref="upload"
              action="/service/admin/upload_pic"
              :on-progress="progress"
              :on-success="politicalInstructor"
              :limit="1"
              :before-upload="$beforeUploadImage"
              list-type="picture-card"
              :data="{token:token}" name="pic">
              <i slot="default" class="el-icon-plus"></i>
            </el-upload> -->
            <MultipleUploadSWithDragort
              :uploadedList.sync="form.zdy_document"
              :uploadMaxLen="5"
              :uploadItemStyles="{ width: '80px', height: '80px' }"
              name="pic"
            >
            </MultipleUploadSWithDragort>
          </template>
        </el-form-item>
        <el-form-item label="是否党员">
          <el-select
            style="width: 300px; margin-bottom: 12px"
            v-model="form.is_party"
          >
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
          <template v-if="form.is_party == 1">
            <!-- <el-upload ref="upload"
              action="/service/admin/upload_pic"
              :on-progress="progress"
              :on-success="partyMember"
              :limit="1"
              :before-upload="$beforeUploadImage"
              list-type="picture-card"
              :data="{token:token}" name="pic">
              <i slot="default" class="el-icon-plus"></i>
            </el-upload> -->
            <MultipleUploadSWithDragort
              :uploadedList.sync="form.party_document"
              :uploadMaxLen="5"
              :uploadItemStyles="{ width: '80px', height: '80px' }"
              name="pic"
            >
            </MultipleUploadSWithDragort>
          </template>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseDialog">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { busMemberEdit } from "@/api/huodongguanliBaomingjilu";
import { getAllWzArea } from "@/api/city";

import MultipleUploadSWithDragort from "@/components/MultipleUploadWithDragSort/index.vue";
export default {
  name: "Compile",
  components: { MultipleUploadSWithDragort },
  data() {
    return {
      dialogVisible: false,
      allWzArea: [],
      areaArray: [],
      token: sessionStorage.getItem("token"),
      form: {
        token: sessionStorage.getItem("token"),
        bus_id: "",
        member_id: "",
        username: "",
        age: "",
        sex: "",
        idcard: "",
        mobile: "",
        area: "",
        area_name: "",
        work_unit: "", //工作单位
        role: "", //职务
        email: "", //邮箱
        education: "", //学历
        is_zdy: "", //指导员
        is_party: "", //党员
        status: "",
        resume: "",
        logo: "",
        party_document: "", //党员照片
        zdy_document: "", //指导员照片
      },
    };
  },
  async created() {
    await this.intAllWzArea();
    this.fetchUserData();
  },
  mounted() {},
  methods: {
    handleOpenDialog(row) {
      console.log("传过来的row", row);
      this.form.bus_id = row.bus_id;
      this.form.member_id = row.id;
      this.form.username = row.username;
      this.form.age = "";
      this.form.sex = row.sex;
      this.form.idcard = row.idcard;
      this.form.mobile = row.mobile;
      this.form.area_name = row.area_name;
      this.form.area = row.area;
      this.form.work_unit = row.work_unit;
      this.form.role = row.role;
      this.form.email = row.email;
      this.form.education = row.education;
      this.form.is_zdy = row.is_zdy;
      this.form.is_party = row.is_party;
      this.form.status = row.status;
      this.form.resume = row.resume;
      this.form.logo = row.logo;
      this.form.party_document = row.party_document;
      this.form.zdy_document = row.zdy_document;
      this.dialogVisible = true;
    },

    // 计算年龄
    fetchUserData() {
      const userData = {
        idcard: this.form.idcard,
      };
      // console.log("身份证号",this.form.idcard);
      this.calculateAge(userData.idcard);
    },
    calculateAge(idcard) {
      const birthYear = parseInt(idcard.substr(6, 4), 10);
      const birthMonth = parseInt(idcard.substr(10, 2), 10);
      const birthDay = parseInt(idcard.substr(12, 2), 10);
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth() + 1;
      const currentDay = today.getDate();
      let age = currentYear - birthYear;
      if (
        currentMonth < birthMonth ||
        (currentMonth === birthMonth && currentDay < birthDay)
      ) {
        age--;
      }
      this.form.idcard = idcard;
      this.form.age = age;
      // console.log("年龄",age);
    },
    // 地区选择
    async intAllWzArea() {
      const allWzAreaResp = await getAllWzArea();
      console.log("_allWzArea", allWzAreaResp);
      const { result, data, msg } = allWzAreaResp.data;
      if (result === 1) {
        this.allWzArea = data;
        // console.log("输出的地区",this.allWzArea)
        this.form.area = data.map((item) => item.code);
        this.form.area_name = data.map((item) => item.name);
        // console.log("area",this.form.area);
        // console.log("area_name",this.form.area_name);
      }
    },

    // 上传指导员,党员图片
    progress(event, file, fileList) {
      console.log("event", event, "file", file, "fileList", fileList);
    },
    // 指导员
    politicalInstructor(response, file, fileList) {
      console.log("res", response);
      if (response.result === 1) {
        this.$message({
          message: response.msg,
          type: "success",
          duration: "2000",
        });
        this.form.zdy_document = response.pic_url;
      } else {
      }
    },
    // 党员
    partyMember(response, file, fileList) {
      console.log("res", response);
      if (response.result === 1) {
        this.$message({
          message: response.msg,
          type: "success",
          duration: "2000",
        });
        this.form.party_document = response.pic_url;
      } else {
      }
    },

    handleCloseDialog() {
      this.dialogVisible = false;
    },
    handleSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const form = cloneDeep(this.form)
          const party_document = (form.party_document || []).join(',')
          const zdy_document = (form.zdy_document || []).join(',')
          const postData = {
            ...form,
            party_document,
            zdy_document
          }
          console.log("_", postData)

          busMemberEdit(postData).then(({ data: res }) => {
            console.log("修改之后的值", res);
            this.$message.success("成功");
            this.$emit("submit");
            this.handleCloseDialog();
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__body {
  padding: 0;
}
/deep/.el-dialog {
  min-width: 875px;
}
/deep/.el-dialog__header {
  padding: 10px 20px 10px;
}
.dialog {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

// 党员,指导员图层
/deep/.el-upload--picture-card {
  margin-top: 10px;
  width: 100px;
  height: 100px;
}
/deep/.el-upload-list__item {
  margin-top: 10px;
  width: 100px;
  height: 100px;
}
/deep/.el-upload--picture-card {
  line-height: 110px;
}
</style>
